module.exports = __webpack_public_path__ + "static/media/3-hybrid.a01e7194.png";